/**
 * Created by SH: 02/20/2020
 */

import {SanEnginePlayer, IExpandAnimateConfig} from "./SanEnginePlayer";
import { SanSpriteSymbol, SanSymState } from "./Symbol/SanSpriteSymbol";

import { ReelEngineController, ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { SanParsedInitData } from "../server/data/SanParsedInitData";
import { SanParsedGameData } from "../server/data/SanParsedGameData";

import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { SanGameConfig } from "../SanGameConfig";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { TimelineMax, Timeline, Power3 } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { IReelSpriteSymbol } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/IReelSpriteSymbol";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { ReelEngineEvent } from "@nolimitcity/slot-game/bin/core/engines/reel/event/ReelEngineEvent";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { SanSymbolData } from "./Symbol/SanSymbolData";
import { BLEND_MODES } from "pixi.js";

export class SanEngineController extends ReelEngineController  {

    private gpGraph:PIXI.Graphics;
    private gpSplitGraph:PIXI.Graphics;

    private spSlices:PIXI.Sprite[] = [];
    
    private tlAnim:TimelineMax;

    private _lockedBar:PIXI.Sprite;

    private attentionSym:string | undefined;

    private fsBarOpen:boolean = false;

    private isFirstSpin:boolean = false;

    private _doubleExpanded: boolean = false;

    public get doubleExpand() : boolean {
        return this._doubleExpanded
    }
    
    public set doubleExpand(v : boolean) {
        this.isActive = !v;
        this._doubleExpanded = v;
    }
    
    public get AllStickySymbols():SanSpriteSymbol[]{
        return this._stickyContainer.children as SanSpriteSymbol[];
    }

    public get reelID():number{
        return this.config.reelID;
    }
    public set reelID(value:number){
        this.config.reelID = value;
    }

    public get AllSymbols():SanSpriteSymbol[]{
        return this._areaContainer.children as SanSpriteSymbol[];
    }

    public get Engine():SanEnginePlayer{ 
        return <SanEnginePlayer>this._engine;
    }

    public getSymbol(symbolID:number):SanSpriteSymbol | undefined {
        return super.getSymbol(symbolID) as SanSpriteSymbol;
    } 

    public get stepPosOffset(): number {
        return 0;//this.state.isIdle ? 0 : this.Engine.reverse ? 1 : -1;
    }

    public get maxHeight():number{
        return this.reelDim.HEIGHT;
    }

    private maskObject:PIXI.Graphics;
    constructor(config:any){
        super(config);
        this.maskObject = <PIXI.Graphics>this.children[0];
    }

    public setAttentionSym(symForAttention:string){
        this.attentionSym =  symForAttention;
    } 

    protected createNewSymbol(id:number, symName:string, state?:string):SanSpriteSymbol {
        const sym:SanSpriteSymbol = new SanSpriteSymbol(id,symName,state);

        if(state == "spin" && sym.symName == this.attentionSym){// ==  ){
            sym.changeState({state: SanSymState.SPIN_ATTENTION})
        }
        return sym;
    }

    private teaseTop:boolean = false;
    public createNextAnimation(state: string, updateState: boolean = false): Timeline {
        if(state == ReelState.STOP || state == ReelState.FAST_STOP){
            this.Engine.Stop2(this.teaseTop,this.getStopDuration());
            while (!this._engine.nextTimeline) this.createNextAnimation(state, updateState);
            return this._engine.nextTimeline;
        }

        if(state == ReelState.STOP_TEASER){
            this.Engine.StopTeaser2();
            while (!this._engine.nextTimeline) this.createNextAnimation(state, updateState);
            return this._engine.nextTimeline;
        }

        return super.createNextAnimation(state, updateState);
    }

    public createStop(isTeasing?: boolean): Timeline {
        this.Engine.Steps = this.showAmount + this.overflowDirection + this.overflowTail;

        if(this.state.isSpinning && !this.Engine.nextTimeline && isTeasing){
            return this.createNextAnimation(ReelState.STOP_TEASER);
        }
        return super.createStop();
    }

    protected createReelEngine(): void {
        this._engine = new SanEnginePlayer(this.engineCallbacks(), this.config.engine_config, this._areaContainer);
    }

    public dataParsed(data:  SanParsedInitData | SanParsedGameData): void {
        super.dataParsed(data);

        if((data.mode == GameMode.FREESPIN || data.nextMode == GameMode.FREESPIN) && (data as SanParsedGameData).rawData && (data as SanParsedGameData).rawData.topRowOpened[this.reelID])
            this.fsBarOpen = true;
        else    
            this.fsBarOpen = false;

        this.isFirstSpin = data.mode == "FREESPIN_SETUP";
    };

    private fsSymbol:{sym:string,val:number} = {sym:"",val:0};
    public setFSSymbol(sym:string,val:number): void {
        this.fsSymbol.sym = sym == "W" ? "" : sym;
        this.fsSymbol.val = val;
    };

    public getStartDelay(): number {
        if (this.isQuickStop) return this.engineConfig.DELAY.QUICK_START;
        else if (GameSetting.isFastSpin) return this.engineConfig.DELAY.FAST_START;
        return this.engineConfig.DELAY.START;
    }

    public getStopDelay(): number {
        if (this.isQuickStop) return this.engineConfig.DELAY.QUICK_STOP;
        else if (GameSetting.isFastSpin) return this.engineConfig.DELAY.FAST_STOP;
        return this.engineConfig.DELAY.STOP;
    }

    public getStartDuration(): number {
        if (this.isQuickStop) return this.engineConfig.DURATION.QUICK_START;
        else if (GameSetting.isFastSpin) return this.engineConfig.DURATION.FAST_START;
        return this.engineConfig.DURATION.START;
    }

    public getStopDuration(): number {
        if (this.isQuickStop) return this.engineConfig.DURATION.QUICK_STOP;
        else if (GameSetting.isFastSpin) return this.engineConfig.DURATION.FAST_STOP;
        return this.engineConfig.DURATION.STOP;
    }

    public set stopReels(value:string[]){
        this._stopReelSet = value;
    }

    public get stopReels():string[]{
        return this._stopReelSet;
    }

    public initReel(_windowAmount?:number, _symInitPos?:number): void {
        this.spSlices = this.createSlices();
        this.initEngine();
        this.setCurrentReelSet(this._nextReelSetName);
        this._symbolAmount = this._showAmount = _windowAmount != undefined ?  _windowAmount : this.engineConfig.WINDOW_AMOUNT;

        let symInitPos: number = _symInitPos != undefined ? _symInitPos : this._stopReelSet.length;

        let possAdded: number = 0;
        let gotSplit:number = -1;
        for (var i = -this.overflowDirection; i < this.windowAmount + this.overflowTail; i++) {
            let symType: string = this._stopReelSet[symInitPos % this._stopReelSet.length];
            if (symType == ReelSymbolName.EMPTY) symType = "X";
            if( symType == ReelSymbolName.WILD){
                gotSplit = i;
                symType = "W_S";
            } 
            const symbol: IReelSpriteSymbol = this.createNewSymbol(i, symType);
            if (i == -this.overflowDirection) possAdded = (symbol.symbolHeight * i) - Math.abs(i) * this.engineConfig.STEP_DISTANCE_PADDING_Y;
            else possAdded += Math.abs(symbol.symbolHeight) + this.engineConfig.STEP_DISTANCE_PADDING_Y;

            symbol.position = new PIXI.Point(0, possAdded);
            this.addSymbol(symbol);
            symInitPos++;
        }

        if(gotSplit >= 0)
        for (var i = 0; i < this.windowAmount; i++) {
            if(gotSplit != i){
                (<SanSpriteSymbol>this.AllWindowSymbols[i]).defineSplit(2);
            }
        }

        this._lockedBar = this.addChild(new PIXI.Sprite(GameResources.getTextures("Reel_Lock")[0]));
        this._lockedBar.anchor.set(0.5,0.5);
        this._lockedBar.position.y += this.engineConfig.STEP_DISTANCE + this.engineConfig.STEP_DISTANCE_PADDING_Y;
        this._lockedBar.position.x = -this._lockedBar.width;
        this._lockedBar.alpha = 0;

        this.setVisibleForOverflowSymbols(false);
        this._hasInit = true;

        let checkReverse: boolean = this.Engine.reverse;
        while (this.tryRemoveSymbol(checkReverse));
        while (this.tryAddNextSymbol(checkReverse));
    }

    protected addChildObjOrder():void{
        super.addChildObjOrder();
        this.gpGraph = this.createGraphic();
        this.gpGraph.alpha = 0;

        this.gpSplitGraph = new PIXI.Graphics();
        this.gpSplitGraph.beginFill(0xFFFFFF, 1);
        this.gpSplitGraph.drawRect(-SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH * 0.5, -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT*0.5,
             SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH, this.reelDim.HEIGHT);
        this.gpSplitGraph.endFill();
        this.gpSplitGraph.alpha = 0;

        this.addChild(this.gpSplitGraph);
    }

    private createSlices():PIXI.Sprite[]{
        const temp:PIXI.Sprite[] = [];

        for(let sli:number = 0; sli < 12; sli++){
            // const sp:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("Sym_Win/Frame")[0]);
            const sp:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("Blink_Splitter")[0]);
            sp.blendMode = BLEND_MODES.ADD;
            sp.anchor.set(0.5,0.5);
            sp.position.y = -45 + (((SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT/(2)) + this.engineConfig.STEP_DISTANCE_PADDING_Y) * sli);
            sp.visible = false;
            temp.push(this.addChild(sp));
        }

        return temp;
    }

    private tlBar:TimelineMax;
    private lockedReel:boolean = false;

    public get isLockedReel():boolean { return this.lockedReel; }
    public reelLocker(close:boolean, duration:number = 0.45):TimelineMax{
        this.tlBar = Helper.timeLineKiller(this.tlBar, new TimelineMax());
        this.mask = this.maskObject;
        if(close){
            this.tlBar.to(this._lockedBar, 0.1, {alpha:1},0);
            this.tlBar.to(this._lockedBar.position, duration, {x:0},0);
            this.tlBar.add(() => this.mask = null!)
        }else{
            this.tlBar.to(this._lockedBar.position, duration, {x:-this._lockedBar.width});
            this.tlBar.to(this._lockedBar, 0.1, {alpha:0},"-=" + 0.1);
        }
        
        this.lockedReel = close;

        return this.tlBar;
    }

    private splitFSTl:TimelineMax;

    public splitFsLand(duration:number,lvl:number = 1):TimelineMax{
        this.splitFSTl = Helper.timeLineKiller(this.splitFSTl, new TimelineMax());
        this.splitFSTl.fromTo(this.gpSplitGraph, duration,{alpha:1},{alpha:0,ease:Power3.easeOut});

        for(let k:number = 0; k <(this.spSlices.length/2 * lvl);k++){
            this.splitFSTl.add(() => {
                const lvlDimFactor:number = lvl;
                const lvlYOffset:number = lvl == 1 ? 45 : 45 + 45/2;
                this.spSlices[k].visible = true;
                this.spSlices[k].position.y = -lvlYOffset + (((SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT/(2*lvl)) + this.engineConfig.STEP_DISTANCE_PADDING_Y) * k);
                this.spSlices[k].scale.set(1 , 1/lvlDimFactor );
            },0);
            this.splitFSTl.fromTo(this.spSlices[k],duration,{alpha:1},{alpha:0.15},0)
        }

        return this.splitFSTl;
    }

    public stopFsLand(duration:number = 0.45):TimelineMax{
        this.splitFSTl = Helper.timeLineKiller(this.splitFSTl, new TimelineMax({
                onComplete: () => this.spSlices.forEach(s => s.visible = false)
        }));

        for(let k:number = 0; k < this.spSlices.length ;k++){
            if(this.spSlices[k].visible)
                this.splitFSTl.fromTo(this.spSlices[k], duration ,{alpha:1}, {alpha:0},0)
        }

        return this.splitFSTl;
    }

    public changeAlpha(alpha:number, duration:number):TimelineMax{
        if(this.gpGraph.alpha == alpha) new TimelineMax();
        this.tlAnim = Helper.timeLineKiller(this.tlAnim, new TimelineMax());
        this.tlAnim.to(this.gpGraph, duration,{alpha:alpha});
        return this.tlAnim;
    }

    public gotNextTimeline(): boolean {
        return !!this.Engine.nextTimeline;
    }

    public prepareExpanding(data: IExpandAnimateConfig):Promise<Timeline>{
        return new Promise((res) => {
            if (data.duration == undefined) data.duration = this.engineConfig.DURATION.EXPAND;

            if(this.Engine.nextTimeline){
                this.Engine.activateNextAnimation();
                this.Engine.activeTimeline.totalProgress(1);
                for (var i = 0; i < this.AllWindowSymbols.length; i++) {
                    this.AllWindowSymbols[i].changeState({
                        state: ReelSymbolStates.NORMAL,
                        duration: 0,
                        forceState:true
                    });
                }
            }
    
            this.state.set(ReelState.EXPAND_SYM);
            res(this.Engine.ExpandSymbol(data));
        })
    }

    public onExpandSymbol(data: IExpandAnimateConfig): void {

        if (data.duration == undefined) data.duration = this.engineConfig.DURATION.EXPAND;

        for (let pos = 0; pos < this.AllWindowSymbols.length; pos++) {
            if (this.AllWindowSymbols[pos].posID < 0 || this.AllWindowSymbols[pos].posID > this.windowBottSymbol.posID) continue;
            this.getSymbol(this.AllWindowSymbols[pos].posID)!.changeState({
                state: ReelSymbolStates.CHANGE_SYMBOL,
                forceState: true,
                type: data.type,
                duration: data.duration! * 0.5,
            });
            this.getSymbol(this.AllWindowSymbols[pos].posID)!.changeSizeBg(data.duration! * 0.5,data.type);
        }
        this.Engine.playExpanding();
    }

    protected onStopStarted(): void {
        const _duration: number = this.getPlayTime();
        const _ease: any = this.getStopEase();

        for (var i = 0; i < this.AllSymbols.length; i++) {
            const sym:SanSpriteSymbol = this.AllSymbols[i];
            sym.changeState({
                state: sym.symName == this.attentionSym ? ReelSymbolStates.LANDING : ReelSymbolStates.NORMAL,
                ease: _ease,
                duration: _duration*0.25,
                newSym: sym.symName == this.attentionSym ? this.isFirstSpin ? "W_J" : this.attentionSym : undefined
            })

            if(sym.symName == "Z") sym.applyMysteryExplosion();
            if(this.fsSymbol.sym != "" && this.fsSymbol.sym != "J_W" && this.fsSymbol.sym != "W" && this.fsSymbol.sym === sym.symName){
                (<SanSpriteSymbol>sym).isFSMarked(this.fsSymbol.val);
            }
        }
        
        EventHandler.dispatchEvent(new GameEvent(ReelEngineEvent.REEL_STOP_SPIN_STARTED, this.reelID));
    }

    public startReel(): void {
        if (this.state.isSpinning) return;
        if (!this.isActive) {
            if (this.visible) {
                if(this.Engine.nextTimeline) this.Engine.activateNextAnimation();
                this.createNextAnimation(ReelState.IDLE);
            }
            return;
        }

        // this.AllSymbols.forEach(sym => { sym.visible = true; });
        this.setVisibleForOverflowSymbols(true);
        this.Engine.activateNextAnimation();

        // Prepare SpinAnimation
        this.createNextAnimation(ReelState.STEP);
    }

    protected setVisibleForOverflowSymbols(value: boolean): void {
        super.setVisibleForOverflowSymbols(value);
        this.mask = value ? this.maskObject : null!; 
    }

    protected onStopAnimationCompleted(): void {
        this.setCurrentReelSet(this._nextReelSetName);

        this.createNextAnimation(ReelState.IDLE, true);

        let checkReverse: boolean = this.Engine.reverse;
        while (this.tryRemoveSymbol(checkReverse));
        while (this.tryAddNextSymbol(checkReverse));
        
        if(this.Engine.nextTimeline) this.Engine.activateNextAnimation();

        EventHandler.dispatchEvent(new GameEvent(ReelEngineEvent.REEL_STOP_COMPLETED, this.reelID));

        this._activeReel = this._nextResultActive;

        this.isQuickStop = false;
        this.setVisibleForOverflowSymbols(false);
    }

    public updateParsedData():void{
        this.setCurrentReelSet(this._nextReelSetName);
        this._activeReel = this._nextResultActive;
    }

    createStart(reverse?:boolean){
        if (reverse === void 0) { reverse = false; }
        this.Engine.reverse = reverse;
        
        if (this.isActive) {
            return this.createNextAnimation(ReelState.START,true);
        }
        else {
            return this.createNextAnimation(ReelState.INACTIVE, true);
        }
    };

    public activateStop():void{
        this.state.set(this.state.subState);
        this.state.set(ReelState.IDLE, true);

        const reelStopReelResult: string[] = this.state.equal(ReelState.QUICK_STOP) ? this._quickStopReelSet : this._stopReelSet;

        this.AllSymbols.forEach(s => {
            s.posID += this.Engine.Steps;
            s.position.y += this.Engine.stepDistance * this.Engine.Steps;
            s.position.y = Math.round(s.position.y);
        });

        let posOffset:number = this.topSymbol.position.y;
        let nextSymindx:number = 4;//this.stopReels.length;
        
        for (var i = 0; i < this.Engine.Steps; i++) {
            const nextSymName: string = reelStopReelResult[nextSymindx] != undefined ? reelStopReelResult[nextSymindx] : this.generateNextSymbol();
            const symbol: IReelSpriteSymbol = this.createNewSymbol(nextSymindx-1, nextSymName, ReelSymbolStates.SPIN);
            posOffset -= Math.abs(symbol.symbolHeight) + this.engineConfig.STEP_DISTANCE_PADDING_Y;
            symbol.position = new PIXI.Point(0, posOffset);
            this.addSymbol(symbol);
            nextSymindx--;
        }

        this.Engine.activateNextAnimation();
    };

    protected findNextSymbol(): string {
        const reelStopReelResult: string[] = this.state.equal(ReelState.QUICK_STOP) ? this._quickStopReelSet : this._stopReelSet;
        return this.state.isStopping && reelStopReelResult[this.Engine.Steps] != undefined ? reelStopReelResult[this.Engine.Steps] : this.generateNextSymbol();
    }

    public calcedPos:PIXI.Point = new PIXI.Point();

    protected onResize(dimData:LayoutDimData):void {
        if(SanGameConfig.instance.REEL_ENGINE_POSITIONS){
            let normalPos:PIXI.Point = MathHelper.pointAdd(SanGameConfig.instance.REEL_ENGINE_POSITIONS[this.reelID], dimData.position);;
            const scaledPos:PIXI.Point = MathHelper.pointMul(normalPos, dimData.scale);
            this.calcedPos = scaledPos; 
            this.position = scaledPos;
        }
        this.scale = dimData.scale!;
        this.AllSymbols.forEach((s) => s.onResize());
    }

    protected generateNextSymbol():string {
        if(!this._nextSymbol) this._nextSymbol = this.genSym.next().value;
        return this._nextSymbol;
    }

    private genSym:Generator<string,string,string>;

    private *getNextSym():Generator<string,string,string>{
        let i:number = 0;
        while(true){
            yield this._currentReelSet[i%this._currentReelSet.length];
            i++;
        } 
    }

    public setCurrentReelSet(name: string): void {

        if(!this.genSym) this.genSym = this.getNextSym();

        if (!!GameConfig.instance.REEL_SETS[name] && GameConfig.instance.REEL_SETS[name].length > 0) {
            
            this._currentReelSet = ArrayHelper.shuffle(GameConfig.instance.REEL_SETS[name][this.reelID ]);

            if(this.fsBarOpen){
                this._currentReelSet.splice(this._currentReelSet.indexOf("W"),1)
                this._currentReelSet.splice(this._currentReelSet.indexOf("S"),1)
            }else{
                const wPos:number = this._currentReelSet.indexOf("W");
                const sPos:number = this._currentReelSet.indexOf("S");
    
                if(wPos >= 0 && sPos >= 0 && Math.abs(wPos-sPos) < 10 ){
                    this._currentReelSet.splice(wPos,1)
                    this._currentReelSet.splice(((sPos+10)%this._currentReelSet.length),0,"W")
                }
            }
            return;
        }

        debugger;
        throw new Error('Error: ReelEngineController.setCurrentReelSet(name: string): Reel ${name} does not contain any symbol!');
    }
}